import {combine, createEffect, createEvent, createStore} from 'effector';
import {createGate} from 'effector-react';

import {createFactoryLine, fetchFactoryLine, fetchFactoryLineDynamicStatistics} from 'api';
import {DateRange} from 'types';
import {Factory, FactoryLine, FactoryLineStatisticsRecord} from 'types/profile';
import {getPastDate} from 'utils/date';

import {loadFactoryFx} from '../factoryDetails';

export const FactoryLineGate = createGate<{factoryId: string; lineId: string}>();

export const loadFactoryLineFx = createEffect(fetchFactoryLine);
export const loadFactoryLineDynamicFx = createEffect(fetchFactoryLineDynamicStatistics);
// Only first line
export const addFactoryLineFx = createEffect(createFactoryLine);

// Future API
// export const loadFactoryLineActivityFx = createEffect<any, FactoryLineActivityRecord[]>();

export const factory$ = createStore<Factory | null>(null);
export const factoryLine$ = createStore<FactoryLine | null>(null);
export const factoryLineDynamicStatistics$ = createStore<FactoryLineStatisticsRecord[]>([]);

export const dateRangeChanged = createEvent<DateRange>();

export const dateRange$ = createStore<DateRange>({
    start: getPastDate(new Date(), 7),
    end: new Date(),
});

// TODO: create sample (effector) from gate and event
export const addFactoryLine = createEvent<{
    name: string;
    code: string;
    factoryId: string;
}>();

export const factoryLineState$ = combine({
    lineId: FactoryLineGate.state,
    dateRange: dateRange$,
    line: factoryLine$,
    lineLoading: loadFactoryLineFx.pending,
    lineDynamicData: factoryLineDynamicStatistics$,
    lineDynamicDataPending: loadFactoryLineDynamicFx.pending,
    factory: factory$,
    factoryLoading: loadFactoryFx.pending,
    createFactoryLinePending: addFactoryLineFx.pending,
});
